import React, { useEffect } from 'react';
import { Route, Switch, useHistory, useLocation } from "react-router-dom";
import styled from 'styled-components';
import { Home } from '../Home/';
import { CampaignDetails } from '../CampaignDetails';
import { Campaigns } from '../Campaigns';
import { Dashboard } from '../Dashboard';
import { Support } from '../Support';
import { Success as SupportSuccess } from '../Support/Success';
import { Clients } from '../Clients';
import { Benefits } from '../Benefits';
import { PrivateRoute } from './PrivateRoute';
import { SupportAdmin } from '../Support/SupportAdmin';
import { CreateCampaign } from '../Campaign';
import { EditCampaign } from '../Campaign/EditCampaign';
import { redirectToSso } from '../utilities';

export const Conatiner = styled.div`
    min-height: calc(100vh - 200px);
    @media screen and (max-width: 690px) {
        min-height: calc(100vh - 330px);
    }
`;

export function ModalSwitch() {
    const location = useLocation<{ openLogin?: null | undefined }>();
    const openLogin = location.state && location.state.openLogin;
    const history = useHistory();

    useEffect(() => {
        if (openLogin) {
            history.push(location.pathname, {});
            redirectToSso();
        }
    }, [openLogin])

    return (
        <Conatiner>
            <Switch>
                <PrivateRoute path={`${process.env.REACT_APP_INTERNAL_URL}support/success`} component={SupportSuccess} />
                <PrivateRoute path={`${process.env.REACT_APP_INTERNAL_URL}support`} component={Support} />
                <PrivateRoute path={`${process.env.REACT_APP_INTERNAL_URL}support-panel`} component={SupportAdmin} adminAccess />
                <PrivateRoute path={`${process.env.REACT_APP_INTERNAL_URL}my-campaigns/:status?`} component={Campaigns} />
                <PrivateRoute path={`${process.env.REACT_APP_INTERNAL_URL}campaign-details/:id`} component={CampaignDetails} />
                <PrivateRoute path={`${process.env.REACT_APP_INTERNAL_URL}campaign/edit/:id`} component={EditCampaign} />
                <PrivateRoute path={`${process.env.REACT_APP_INTERNAL_URL}dashboard`} component={Dashboard} />
                <PrivateRoute path={`${process.env.REACT_APP_INTERNAL_URL}create-campaign`} component={CreateCampaign} />
                <PrivateRoute path={`${process.env.REACT_APP_INTERNAL_URL}clients`} component={Clients} adminAccess />
                <Route path={`${process.env.REACT_APP_INTERNAL_URL}benefits`}>
                    <Benefits />
                </Route>
                <Route exact path={process.env.REACT_APP_INTERNAL_URL}>
                    <Home />
                </Route>
            </Switch>
        </Conatiner>
    )
}
